// source of code:  https://www.cssscript.com/confetti-falling-animation/

const maxParticleCount = 150 //set max confetti count
const particleSpeed = 3 //set the particle animation speed

export const startConfetti = startConfettiInner //call to start confetti animation

const colors = [
  'DodgerBlue',
  'OliveDrab',
  'Gold',
  'Pink',
  'SlateBlue',
  'LightBlue',
  'Violet',
  'PaleGreen',
  'SteelBlue',
  'SandyBrown',
  'Chocolate',
  'Crimson',
]
let streamingConfetti = false
let animationTimer = null
const particles = []
let waveAngle = 0

export function resetParticle(particle, width, height) {
  particle.color = colors[(Math.random() * colors.length) | 0]
  particle.x = Math.random() * width
  particle.y = Math.random() * height - height
  particle.diameter = Math.random() * 10 + 5
  particle.tilt = Math.random() * 10 - 10
  particle.tiltAngleIncrement = Math.random() * 0.07 + 0.05
  particle.tiltAngle = 0

  return particle
}

function startConfettiInner() {
  if (document.querySelector('#confetti-canvas')) {
    return
  }

  const canvas = document.createElement('canvas')

  const width = document.body.clientWidth - 16
  const height = document.documentElement.scrollHeight

  window.requestAnimFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 16.6666667)
      }
    )
  })()

  const resizeHandler = () => {
    canvas.width = document.body.clientWidth
    canvas.height = window.innerHeight
  }

  canvas.setAttribute('id', 'confetti-canvas')
  canvas.setAttribute('style', 'display:block;z-index:1;pointer-events:none;position: absolute')
  document.body.prepend(canvas)
  canvas.width = width - 8
  canvas.height = height
  window.addEventListener('resize', resizeHandler, true)

  const context = canvas.getContext('2d')

  while (particles.length < maxParticleCount) particles.push(resetParticle({}, width, height))
  streamingConfetti = true
  if (animationTimer === null) {
    ;(function runAnimation() {
      context.clearRect(0, 0, document.body.clientWidth, window.innerHeight)
      if (particles.length === 0) animationTimer = null
      else {
        updateParticles()
        drawParticles(context)
        animationTimer = requestAnimFrame(runAnimation)
      }
    })()
  }

  setTimeout(() => {
    streamingConfetti = false
  }, 1000)

  setTimeout(() => {
    window.removeEventListener('resize', resizeHandler, true)
    canvas.remove()
  }, 5000)
}

function drawParticles(context) {
  let particle
  let x

  for (let i = 0; i < particles.length; i++) {
    particle = particles[i]
    context.beginPath()
    context.lineWidth = particle.diameter
    context.strokeStyle = particle.color
    x = particle.x + particle.tilt
    context.moveTo(x + particle.diameter / 2, particle.y)
    context.lineTo(x, particle.y + particle.tilt + particle.diameter / 2)
    context.stroke()
  }
}

function updateParticles() {
  const width = document.body.clientWidth
  const height = window.innerHeight
  let particle

  waveAngle += 0.01
  for (let i = 0; i < particles.length; i++) {
    particle = particles[i]
    if (!streamingConfetti && particle.y < -15) particle.y = height + 100
    else {
      particle.tiltAngle += particle.tiltAngleIncrement
      particle.x += Math.sin(waveAngle)
      particle.y += (Math.cos(waveAngle) + particle.diameter + particleSpeed) * 0.5
      particle.tilt = Math.sin(particle.tiltAngle) * 15
    }
    if (particle.x > width + 20 || particle.x < -20 || particle.y > height) {
      if (streamingConfetti && particles.length <= maxParticleCount)
        resetParticle(particle, width, height)
      else {
        particles.splice(i, 1)
        i--
      }
    }
  }
}
